export default {
  SWAPPED: "inverted",
  STRAIGHT: "normal",
};
